<template>
  <div class="auth-terms" v-loading="loading">
    <div v-html="confirmPara" />
<!--
    <p>
      You are reminded that the use of Contacts Lists is governed by the <a href="#" target="_blank">Code of
      Practice</a>.
      In addition, the use of information from the electoral roll is also governed by the Electoral Act 2017. Section 51
      of the Act permits
      use of enrolment information for permitted purpose only, being, in the case of Party:<br/>
      (a) any purpose in connection with an election;<br/>
      (b) monitoring the accuracy of enrolment information kept and maintained by the Electoral Commissioner; and<br/>
      (c) any purpose prescribed by the regulations.
    </p>
    -->
    <el-checkbox v-model="agree">{{confirmAgreement}}
    </el-checkbox>
    <el-alert v-if="error" title="Authentication failed" type="error" :description="error" show-icon></el-alert>
    <el-button type="primary" class="btn-confirm" :disabled="!agree" @click="acceptTerms">Continue</el-button>
  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex'

export default {
  data() {
    return {
      agree: false
    }
  },
  computed: {
    ...mapState('auth', [
      'loading',
      'error',
      'authConfig'
    ]),
    confirmPara() {
      // todo: add sanitation etc.?
      return this.authConfig['login-click-wrap-contact']
    },
    confirmAgreement() {
      return this.authConfig['login-click-wrap-agreement']
    }
  },
  methods: {
    ...mapActions('auth', ['confirmAgree']),
    // apply redirect here when agreed.
    async acceptTerms() {
      await this.confirmAgree();
      if (!this.error) {
        window.location = '/';
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.auth-terms {
  p {
    font-size: 0.925rem;
    line-height: 24px;
    margin-top: 0;

    a {
      color: #67C23A;
      text-decoration: none;
      font-weight: 600;

      &:hover {
        color: #85ce61;
      }
    }
  }

  .el-checkbox {
    font-weight: 600;
    color: #010101;

    > > > .el-checkbox__input {
      vertical-align: top;
    }

    > > > .el-checkbox__label {
      white-space: pre-wrap;
      padding-right: 10px;
    }
  }

  .btn-confirm {
    margin-top: 18px;
    font-weight: bold;
    font-size: 0.945rem;
    width: 100%;
    padding-top: 18px;
    padding-bottom: 18px;
  }
}
</style>
